export default __webpack_public_path__ + "static/media/SOU-logo.a401d13d.png";